import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/szechenyi_terv_plusz-poliol-540x.jpg")